import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import type {
  IAppEvent,
  ICreateAppEventPayload,
  IDeleteAppEventPayload,
  IGetAppEventsPayload,
  IUpdateAppEventPayload,
} from '~/types/event'

import { createAppEvent, deleteAppEvent, getAppEvents, updateAppEvent } from '~/api/application-events'

////////// KEYS //////////
export const eventsKeys = {
  all: ['app-events'] as const,
  list: (payload: IGetAppEventsPayload) => [...eventsKeys.all, 'list', payload] as const,
}

////////// QUERIES //////////
export const useAppEventsListQuery = ({
  enabled,
  ...payload
}: IGetAppEventsPayload & { enabled?: boolean }): UseQueryResult<IAppEvent[]> => {
  return useQuery({
    enabled: enabled !== false,
    queryFn: () => getAppEvents(payload),
    queryKey: eventsKeys.list(payload),
  })
}

//////// MUTATIONS //////////
export const useCreateAppEventMutation = (): UseMutationResult<IAppEvent, unknown, ICreateAppEventPayload, unknown> => {
  return useMutation({ mutationFn: createAppEvent })
}

export const useUpdateAppEventMutation = (): UseMutationResult<IAppEvent, unknown, IUpdateAppEventPayload, unknown> => {
  return useMutation({ mutationFn: updateAppEvent })
}

export const useDeleteAppEventMutation = (): UseMutationResult<IAppEvent, unknown, IDeleteAppEventPayload, unknown> => {
  return useMutation({ mutationFn: deleteAppEvent })
}
